import CircularProgress from '@material-ui/core/CircularProgress'
import { withStyles } from '@material-ui/core/styles'
import Popup from 'Components/Popup'
import React, { useState } from 'react'
import { Document, Page, pdfjs } from 'react-pdf'
import useGraphQLFetch from 'Utils/Hooks/useGraphQLFetch'
import { getCampaignFlyerInfo } from '../../gql/getFlyerInfo'
import styles from './styles'

const PDFPreviewPopup = ({ classes, onCancel, isOpen, campaignId }) => {
  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${
    pdfjs.version
  }/pdf.worker.min.js`

  if (!isOpen) {
    return null
  }

  const [url, setUrl] = useState(null)

  const { isLoaded: flyerIsLoaded } = useGraphQLFetch({
    fetchFn: getCampaignFlyerInfo,
    defaultFetchArgs: {
      campaignId: +campaignId,
    },
    mapResponse: data => {
      setUrl(data.campaignFlyerInfo.s3Link)
    },
    skipFetchOnInit: false,
  })

  return (
    <Popup
      onCancel={onCancel}
      showCross={true}
      body={
        flyerIsLoaded ? (
          url !== '' ? (
            <div>
              <a href={url} target="_blank" rel="noreferrer">
                Save as PDF
              </a>
              <Document
                file={url}
                // eslint-disable-next-line no-console
                onDocumentLoad={doc => console.log(doc)}
                // eslint-disable-next-line no-console
                onLoadError={console.error}
                className={classes.designsPreview}
                loading={<CircularProgress size={25} />}
              >
                <div className={classes.flyerPage}>
                  <div>Front</div>
                  <Page pageNumber={1} height={350} />
                </div>
                <div className={classes.flyerPage}>
                  <div>Back</div>
                  <Page pageNumber={2} height={350} />
                </div>
              </Document>
            </div>
          ) : (
            <div>'Flyer was not created yet'</div>
          )
        ) : (
          <CircularProgress size={25} />
        )
      }
      footer={<div />}
    />
  )
}

export default withStyles(styles)(PDFPreviewPopup)
